export const internalRoutes = {
  helpdesk: "/api/public/helpdesk",
  departments: "/api/public/department",
  updateEmail: "/api/auth/update-email",
  cancelUpdateEmail: "/api/auth/cancel-update-email",
} as const;
